// libs
import { createContext } from '@lyearn/core/utils/context';

// types
import { GenerativeTaskContextProps } from '../types';

export const [GenerativeTaskContextProvider, useGenerativeTaskContext] =
  createContext<GenerativeTaskContextProps>('GenerativeTaskContext');
